<template>
  <component :is="form && form.data.value === undefined ? 'div' : 'b-card'">
    <b-alert
        variant="danger"
        :show="form.data.value === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
    </b-alert>
    <b-tabs
        v-if="form.data.value"
        pills
    >
      <b-tab active>
        <template #title>
          <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Information</span>
        </template>
        <email-conf-edit-tab
            :form-data="form"
            class="mt-2 pt-75"
        />
      </b-tab>


    </b-tabs>
  </component>
</template>

<script>
import {BAlert, BCard, BLink, BTab, BTabs,} from 'bootstrap-vue'
import store from '@/store'
import EmailConfEditTab from './EmailConfEditTab.vue'
import {FormConfig, PropertyConfig, FieldType} from '../../common/index.d.ts'
import {ref} from '@vue/composition-api'

export default {
  components: {

    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    EmailConfEditTab,
  },
  setup() {
    const homeData = ref(null)
    let arr = [
      new PropertyConfig("smtp_server", "Smtp Server", FieldType.TEXT),
      new PropertyConfig("username", "Username", FieldType.TEXT),
      new PropertyConfig("password", "Password", FieldType.PASSWORD),
      new PropertyConfig("receivers", "Receivers", FieldType.TEXT),
      new PropertyConfig("sender", "Sender", FieldType.TEXT),
      new PropertyConfig("port", "Port", FieldType.TEXT),
      new PropertyConfig("auth", "Auth", FieldType.SWITCH),
      new PropertyConfig("starttls", "Starttls", FieldType.SWITCH),
      new PropertyConfig("ssl_enable", "Ssl Enable", FieldType.SWITCH),
    ];
    let form = new FormConfig(homeData, arr, "emailConf");
    // let USER_APP_STORE_MODULE_NAME = 'app-email'
    // if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    // })

    store.dispatch('app-cms/fetchEmailConf')
        .then(response => {
          let res = response.data.data
          form.data.value = res;
        })
        .catch(error => {
          if (error.response.status === 404) {
            form.data.value = undefined
          }
        })
    return {
      form,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/tree.scss";
</style>
